<ng-container *ngIf="!canShow">
  <div class="container uploader-status text-center">
    <div class="d-inline-block mt-5">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</ng-container>
<div class="container" *ngIf="canShow">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row mt-4">
      <div class="col-md-7">
        <h2 *ngIf="!isSubscriptionInfo">Subscribe to our service!</h2>
        <h2 *ngIf="isSubscriptionInfo">
          You currently do not have an active subscription!<br /><span style="font-size: 16px; color:#f92c7a">Fill data on form and subscribe now! You get:</span>
        </h2>
        <div class="row pt-3">
          <div class="col-md-3 p-1 text-center">
            <i class="far fa-images icon"></i>
            <div class="in-content p-2">
              Unlimited pictures for Posts and Messages
            </div>
          </div>
          <div class="col-md-3 p-1 text-center">
            <i class="fas fa-eye-slash icon"></i>
            <div class="in-content p-2">Ad free surfing</div>
          </div>
          <div class="col-md-3 p-1 text-center">
            <i class="fas fa-ad icon"></i>
            <div class="in-content p-2">
              No third party advertisement in your ads
            </div>
          </div>
          <div class="col-md-3 p-1 text-center">
            <i class="fas fa-bullhorn icon"></i>
            <div class="in-content p-2">Your ads appear on top</div>
          </div>
          <div class="col-md-3 p-1 text-center">
            <i class="far fa-id-badge icon"></i>
            <div class="in-content p-2">Verified badge on your user</div>
          </div>
          <div class="col-md-3 p-1 text-center">
            <i class="fas fa-laugh-wink icon"></i>
            <div class="in-content p-2">Use emojis in ad and messages</div>
          </div>
          <div class="col-md-3 p-1 text-center">
            <i class="fas fa-certificate icon"></i>
            <div class="in-content p-2">Premium label</div>
          </div>
        </div>

      </div>

      <div class="col-md-5">
        <div class="row">
          <div class="col-12 mb-2">
            <div class="row mb-2" style="padding-left: 15px; width: 475px">
              <div class="col-md-5 d-flex align-items-center" style="padding-right: 0">
                <b class="font-ac">100% Secure Payment!</b>
              </div>
              <div class="col-md-6 d-flex" style="padding-left: 0">
                <div class="d-flex align-items-center"> <b style="font-size:12px">Secured By:</b></div>
                <div class="pl-3">
                  <img src="/images/authorizenet.png">
                </div>
              </div>
            </div>
            <div class="row" style="padding-left: 15px">
              <div class="col-12 mb-2" style="font-size: 14px">
                <b>Charge will appear on your credit card statement as "Armax Technology"</b>
              </div>
            </div>
              <div class="col-md-12">
                <mat-form-field class="full-width">
                  <mat-select placeholder="Period"
                              formControlName="subscriptionPeriod"
                              (selectionChange)="show($event)">
                    <mat-option value="1">
                      1 year subscription $4.60/mo - <b>$55.20</b>
                    </mat-option>
                    <mat-option value="2"> Monthly - <b>$6.99</b> cancel anytime</mat-option>
                    <mat-option value="3"> <b>$1.99</b> per single premium ad - no monthly subscription</mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="priceInfo" *ngIf="showSave == '1'">
                  <span>$55.20 / year</span>
                  <span class="showsave">save $28.68</span>
                </div>
                <div class="priceInfo" *ngIf="showSave == '2'">
                  $83,88 / year
                </div>
              </div>
            <div class="col-md-12">
              <mat-form-field class="w-100">
                <input formControlName="firstName"
                       matInput
                       placeholder="First name *" />
                <mat-error *ngIf="form.controls['firstName'].hasError('required')">
                  Required field
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field class="w-100">
                <input formControlName="lastName"
                       matInput
                       placeholder="Last name *" />
                <mat-error *ngIf="form.controls['lastName'].hasError('required')">
                  Required field
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field class="w-100">
                <input formControlName="zip"
                       matInput
                       placeholder="Zip Code *" />
                <mat-error *ngIf="form.controls['zip'].hasError('required')">
                  Required field
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field class="w-100">
                <input formControlName="creditCard"
                       matInput
                       placeholder="Credit Card *"
                       id="cc-number"
                       type="tel"
                       autocomplete="cc-number"
                       ccNumber />
                <mat-error *ngIf="form.controls['creditCard'].hasError('ccNumber')">
                  Please enter a valid credit card number.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="row pr-3 m-0">
              <div class="col-md-12">Expiration Date</div>
              <div class="col-md-5">
                <mat-form-field class="w-100">
                  <input formControlName="expirationDateMonth"
                         matInput
                         placeholder="MM*"
                         id="cc-exp-date-m"
                         type="tel" />
                  <mat-error *ngIf="
                    form.controls['expirationDateMonth'].hasError('required')
                  ">
                    Please enter a valid expiration date - MM
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="p-0 col-md-1 pt-3">
                /
              </div>
              <div class="col-md-5 p-0 ">
                <mat-form-field class="w-100">
                  <input formControlName="expirationDateYear"
                         matInput
                         placeholder="YYYY*"
                         id="cc-exp-date-y"
                         type="tel" />
                  <mat-error *ngIf="
                    form.controls['expirationDateYear'].hasError('required')
                  ">
                    Please enter a valid expiration date - YYYY
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-12">
              <mat-form-field class="w-100">
                <input formControlName="cvc"
                       matInput
                       placeholder="CVC *"
                       id="cc-cvc"
                       type="tel"
                       autocomplete="off"
                       ccCVC />
                <mat-error *ngIf="form.controls['cvc'].hasError('required')">
                  Please enter a CVC number
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row mt-2 m-0">
          <div class="col-12 m-0">
            <button class="w-100 create-button p-1"
                    mat-flat-button
                    color="primary"
                    type="submit"
                    [disabled]="creating">
              <span *ngIf="!creating">
                {{ submitButtonText }}
              </span>
              <mat-spinner *ngIf="creating" diameter="30"></mat-spinner>

            </button>

          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-template #errorDialog>
    <h2 matDialogTitle>Create subscription error</h2>
    <p matDialogContent><em>{{errorMessage}}</em></p>
    <mat-dialog-actions>
      <button mat-button matDialogClose style="margin: auto">Ok</button>
    </mat-dialog-actions>
  </ng-template>
</div>
